  <div class="neptune-modal-cover open">
    <div
      id="photo-view-window-modal"
      class="flex flex-col gap-4 p-8 max-w-md items-center bg-white"
    >
      <!-- Title and close button -->
      <section
        id="photo-view-window-toolbar"
        class="flex justify-between items-center pb-2 w-full neptune-border-b-1 border-sky-blue"
      >
        <span class="title text-2xl">View Details</span>
        <button
          id="photo-view-window-close-button"
          class="neptune-button-white border-none p-0"
          (click)="onIconCloseClicked()"
        >
          <img
            alt="Close Icon"
            src="/assets/shared-icons/neptune-icon-blue-close.svg"
            class="w-6 h-6 flex self-center"
          />
        </button>
      </section>

      <!-- Photo and navigation arrows -->
      <section
        id="photo-view-window-gallery"
        class="flex flex-col justify-center items-center gap-2 w-full"
      >
        <section
          id="photo-view-window-carousal"
          class="flex justify-between items-center gap-4 w-full"
        >
          <div
            id="photo-view-window-left-icon"
            class="neptune-carousal-button"
            (click)="showPrevSlide()"
          >
            <img
              alt="Left Arrow"
              src="/assets/shared-icons/neptune-icon-black-chevron-left.svg"
              class="w-5 h-5"
            />
          </div>

          <div id="photo-view-window-image">
            <img
              alt="Photo"
              [src]="photosList[currentSlideIndex].photoUrl"
              class="w-72 h-72 object-contain"
            />
          </div>

          <div
            id="photo-view-window-right-icon"
            class="neptune-carousal-button"
            (click)="showNextSlide()"
          >
            <img
              alt="Right Arrow"
              src="/assets/shared-icons/neptune-icon-black-chevron-right.svg"
              class="w-5 h-5"
            />
          </div>
        </section>

        <section
          id="photo-view-window-pagination"
          class="text-xs text-white py-1 px-2 rounded-full bg-black/50"
        >
          {{ currentSlideIndex + 1 }} / {{ photosList.length }}
        </section>
      </section>

      <!-- Photo details -->
      <section
        id="photo-view-window-information"
        class="flex flex-col gap-2 w-full"
      >
        <span
          id="photo-view-window-date"
          class="capitalize text-neptune-color-fg-muted text-sm font-medium"
        >
          {{ photosList[currentSlideIndex].endDate | date: "longDate" : "UTC" }}
          | {{ photosList[currentSlideIndex].ecolabRepName }}
        </span>
        <span
          id="photo-view-window-customer-name"
          class="capitalize text-black text-base font-medium"
        >
          {{ photosList[currentSlideIndex].description }}
        </span>
        <span
          id="photo-view-window-location"
          class="capitalize text-neptune-color-fg-muted text-sm"
        >
          {{ photosList[currentSlideIndex].customerName }}
        </span>
      </section>

      <!-- Action buttons -->
      <section
        id="photo-view-window-actions"
        class="w-full flex justify-between items-stretch"
      >
        <button
          id="photo-view-report"
          class="neptune-button-white-link min-w-44"
        >
          <a
            target="_blank"
            [href]="
              viewReportURL +
              photosList[currentSlideIndex].workOrderId +
              '/view'
            "
          >
            <img
              alt="View Report"
              src="/assets/shared-icons/neptune-icon-blue-link-out.svg"
            />
            <span class="">View Report</span>
          </a>
        </button>

        <button
          id="photo-view-download"
          class="neptune-button-blue min-w-44"
          (click)="downloadImage()"
        >
          <img
            alt="Download Image"
            src="/assets/shared-icons/neptune-download-icon.svg"
          />
          Download Photo
        </button>
      </section>
    </div>
  </div>

  <div class="neptune-modal-cover open" *ngIf="showModal"></div>
  <app-export-dialog
    *ngIf="showModal"
    [isDownloading]="false"
    [fileName]="fileName"
    [title]="downloadTitle"
    [buttonText]="'OK'"
    (export)="handleDownload($event)"
    (cancel)="closeModal()"
    [showSelectFileType]="false"
  >
  </app-export-dialog>

